// Das Vokabular der Ereignisse an einer Stelle — Liste und Feed sprechen
// dieselben Woerter. Die Datenbank spricht englische Konstanten, die
// Oberflaeche deutsch.

import type { ChipTone } from '../components/common/Chip'

export const EVENT_TYPES: Record<string, string> = {
  EARNINGS: 'Quartalszahlen',
  DIVIDEND: 'Dividende',
  AGM: 'Hauptversammlung',
  CAPITAL_MARKETS_DAY: 'Kapitalmarkttag',
  INDEX_REBALANCE: 'Index-Anpassung',
  RATE_DECISION: 'Zinsentscheid',
  CPI_RELEASE: 'Inflationsdaten',
  EXPIRY_DAY: 'Verfallstag',
  INVENTORY_REPORT: 'Lagerbestände',
  OPEC_MEETING: 'OPEC-Sitzung',
  HARVEST_REPORT: 'Erntebericht',
  OTHER: 'Sonstiges',
}

export const STATUS_TEXTE: Record<string, string> = {
  EXPECTED: 'erwartet',
  CONFIRMED: 'bestätigt',
  HAPPENED: 'eingetreten',
  CANCELLED: 'abgesagt',
  POSTPONED: 'verschoben',
}

/** Die Art in Worten — bei Sonstigem die Pflicht-Bezeichnung. */
export function artText(e: { event_type: string; other_label: string | null }): string {
  return e.event_type === 'OTHER' && e.other_label
    ? e.other_label
    : EVENT_TYPES[e.event_type] ?? e.event_type
}

export function statusTon(status: string): ChipTone {
  if (status === 'CANCELLED') return 'bad'
  if (status === 'POSTPONED') return 'warn'
  if (status === 'CONFIRMED') return 'info'
  if (status === 'HAPPENED') return 'good'
  return 'neutral'
}
